export default "__VITE_ASSET__5r4PT095__"